import React from 'react'

import {useEditPipeline} from '../../../../../EditPipelinePage/EditPipelinePage.hooks'
import {getPipelineErrors} from '../../../../../EditPipelinePage/EditPipelinePage.selectors'

import styles from './SidebarFooter.css'

import SvgIcon from 'src/components/common/SvgIcon/SvgIcon'
import {useAppSelector} from 'src/hooks/react-redux'

type Props = {
  children?: React.ReactNode
}

function SidebarFooter({children}: Props) {
  const {hasChanges} = useEditPipeline()
  const errorCount = useAppSelector(getPipelineErrors).length

  return (
    <div className={styles.container}>
      <div className={styles.status}>
        {hasChanges && <span>{'You have unsaved changes'}</span>}
        {errorCount > 0 && (
          <span className={styles.errors}>
            <SvgIcon className={styles.errorIcon} icon={'muted'} title={'Error'} />
            {errorCount}
          </span>
        )}
      </div>
      {children}
    </div>
  )
}

export default SidebarFooter
